import { TextField, MenuItem, Grid } from '@mui/material';
import React from 'react';

interface Payee {
  id: string | number;
  firstName?: string;
  lastName?: string;
  companyName?: string;
  email?: string;
}

interface PayeeSelectorProps {
  payees: Payee[];
  payeeId: string | number;
  setPayeeId: (id: string | number) => void;
}

export default function PayeeSelector({ payees, payeeId, setPayeeId }: PayeeSelectorProps) {
  return (
    <Grid item xs={12} sm={6}>
      <TextField
        select
        label="Payee"
        value={payeeId}
        onChange={(e) => setPayeeId(e.target.value)}
        fullWidth
        size="small"
        variant="outlined"
      >
        <MenuItem value="">
          <em>Select Payee</em>
        </MenuItem>
        {payees.map((p) => (
          <MenuItem key={p.id} value={p.id}>
            {p.firstName && `${p.firstName} ${p.lastName}`} {p.companyName && `${p.companyName}`} {p.email && `(${p.email})`}
          </MenuItem>
        ))}
      </TextField>
    </Grid>
  );
}
